(function () {
  'use strict';

  var REBUY_RENDER_EVENTS = [
    'rebuy.ready',
    'rebuy.productsReady',
    'rebuy.productsChange',
    'rebuy.change',
    'rebuy.refresh',
    'rebuy.show'
  ];

  var REBUY_SRC = 'https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=' +
    encodeURIComponent(window.rebuyShopDomain || (window.rebuyConfig && window.rebuyConfig.shop) || location.hostname);

  function rebuyUsable() {
    return !!(window.Rebuy && typeof window.Rebuy.reinit === 'function');
  }

  function rebuyRescan() {
    if (!rebuyUsable()) return false;
    try { window.Rebuy.reinit(); } catch (e) { return false; }
    return true;
  }

  function unmountedPlaceholders(root) {
    return Array.prototype.filter.call(
      (root || document).querySelectorAll('[data-rebuy-id]'),
      function (el) { return !el.querySelector('.rebuy-widget'); }
    );
  }

  var reloading = false;
  var reloadAttempts = 0;

  function reloadRebuy() {
    if (reloading || reloadAttempts >= 3) return;
    reloading = true;
    reloadAttempts++;

    try { delete window.Rebuy; } catch (e) { window.Rebuy = undefined; }

    var script = document.createElement('script');
    script.async = true;
    script.src = REBUY_SRC + '&retry=' + reloadAttempts;
    script.onerror = function () { reloading = false; };
    script.onload = function () {
      var waited = 0;
      var timer = window.setInterval(function () {
        if (rebuyUsable()) {
          window.clearInterval(timer);
          reloading = false;
          rebuyRescan();
        } else if ((waited += 250) >= 15000) {
          window.clearInterval(timer);
          reloading = false;
        }
      }, 250);
    };
    document.head.appendChild(script);
  }

  function recoverRebuy(root) {
    if (!unmountedPlaceholders(root).length) return;
    if (!rebuyRescan()) reloadRebuy();
  }

  document.addEventListener('rebuy.add', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.rerender === 'function') drawer.rerender();
    if (typeof drawer.open === 'function') drawer.open();

    [0, 600, 2000, 5000].forEach(function (delay) {
      window.setTimeout(function () { recoverRebuy(drawer); }, delay);
    });
  });

  var EQUALISE_SELECTORS = [
    '.rebuy-product-title',
    '.rebuy-product-media',
    '.rebuy-product-info',
    '.wrap-actions',
    '.rebuy-button-actions'
  ];

  function equaliseGroup(widget, selector) {
    var els = Array.prototype.slice.call(widget.querySelectorAll(selector));
    if (!els.length) return;

    els.forEach(function (el) { el.style.height = ''; });
    if (els.length < 2) return;

    var rows = [];
    els.forEach(function (el) {
      if (!el.offsetParent && el.offsetHeight === 0) return; // hidden
      var top = Math.round(el.getBoundingClientRect().top + window.pageYOffset);
      var row = null;
      for (var i = 0; i < rows.length; i++) {
        if (Math.abs(rows[i].top - top) <= 2) { row = rows[i]; break; }
      }
      if (!row) { row = { top: top, els: [] }; rows.push(row); }
      row.els.push(el);
    });

    rows.forEach(function (row) {
      if (row.els.length < 2) return;
      var tallest = 0;
      row.els.forEach(function (el) {
        tallest = Math.max(tallest, el.getBoundingClientRect().height);
      });
      row.els.forEach(function (el) { el.style.height = Math.ceil(tallest) + 'px'; });
    });
  }

  function decorateBlocks(widget) {
    widget.querySelectorAll('.rebuy-product-block').forEach(function (block) {
      var wrap = block.querySelector('.rebuy-product-block-wrap');
      if (!wrap) return;
      var hasSizeSelect = !!block.querySelector('.rebuy-product-options .rebuy-select.variant-select');
      wrap.classList.toggle('no-size', !hasSizeSelect);
    });
  }

  function positionUpsellArrows() {
    document.querySelectorAll('.product_upsell').forEach(function (container) {
      var content = container.querySelector('.rebuy-widget.is-visible .rebuy-widget-content');
      if (!content) return;

      var title = content.querySelector('.primary-title');
      var grid = content.querySelector('.rebuy-product-grid');
      if (!title || !grid) return;

      var loose = grid.querySelectorAll('.flickity-button');
      var wrap = content.querySelector('.flickity-button-wrap');

      if (!loose.length && wrap && wrap.children.length) return;
      
      if (!loose.length) return;

      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'flickity-button-wrap';
      } else {
        // Flickity rebuilt its buttons - drop the stale ones.
        while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
      }
      loose.forEach(function (button) { wrap.appendChild(button); });

      var titleArrow = content.querySelector('.rebuy-title-arrow');
      if (!titleArrow) {
        titleArrow = document.createElement('div');
        titleArrow.className = 'rebuy-title-arrow';
        title.parentNode.insertBefore(titleArrow, title);
      }
      if (title.parentNode !== titleArrow) titleArrow.appendChild(title);
      if (wrap.parentNode !== titleArrow) titleArrow.appendChild(wrap);
    });
  }

  var arrowTimer = null;
  var arrowTries = 0;
  function ensureUpsellArrows() {
    if (arrowTimer !== null) { window.clearTimeout(arrowTimer); arrowTimer = null; }
    positionUpsellArrows();

    var container = document.querySelector('.product_upsell');
    if (!container) return;
    if (container.querySelector('.rebuy-title-arrow .flickity-button-wrap .flickity-button')) return;
    if (arrowTries++ > 200) return; // ~30s, then stop
    arrowTimer = window.setTimeout(ensureUpsellArrows, 150);
  }

  var pendingFrame = null;
  var pendingTimer = null;

  function clipUpsellViewport() {
    document.querySelectorAll('.product_upsell .flickity-viewport').forEach(function (vp) {
      var cell = vp.querySelector('.rebuy-product-block');
      if (!cell) return;
      var height = Math.ceil(cell.getBoundingClientRect().height);
      if (height > 0) vp.style.height = height + 'px';
    });
  }

  function applyToWidgets() {
    arrowTries = 0;
    ensureUpsellArrows();
    document.querySelectorAll('.rebuy-widget').forEach(function (widget) {
      decorateBlocks(widget);
      EQUALISE_SELECTORS.forEach(function (selector) {
        equaliseGroup(widget, selector);
      });
    });
    clipUpsellViewport();
  }

  function refreshWidgets() {
    function run() {
      if (pendingFrame !== null) { window.cancelAnimationFrame(pendingFrame); pendingFrame = null; }
      if (pendingTimer !== null) { window.clearTimeout(pendingTimer); pendingTimer = null; }
      applyToWidgets();
    }
    if (pendingFrame !== null) window.cancelAnimationFrame(pendingFrame);
    if (pendingTimer !== null) window.clearTimeout(pendingTimer);
    pendingFrame = window.requestAnimationFrame(run);
    pendingTimer = window.setTimeout(run, 150);
  }

  REBUY_RENDER_EVENTS.forEach(function (name) {
    document.addEventListener(name, refreshWidgets);
  });
  window.addEventListener('resize', refreshWidgets);
  window.addEventListener('load', refreshWidgets);

  if (window.MutationObserver && document.body) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList.contains('rebuy-widget') || node.querySelector('.rebuy-widget')) {
            refreshWidgets();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('load', function () {
    [6000, 12000, 20000, 30000].forEach(function (delay) {
      window.setTimeout(function () { recoverRebuy(); }, delay);
    });
  });

  document.addEventListener('load', function (event) {
    var target = event.target;
    if (target && target.tagName === 'IMG' && target.closest('.rebuy-widget')) {
      refreshWidgets();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.dropdown__button');
    if (!button) return;
    button.classList.toggle('dropdown__button_active');
    var swatches = button.closest('.rebuy-color-swatches');
    if (!swatches) return;
    swatches.querySelectorAll('.variant-option').forEach(function (el) {
      el.classList.toggle('dropdown__list_visible');
    });
  });

  function attachGetURL(widget) {
    if (!widget) return;
    var fn = typeof window.getURL === 'function' ? window.getURL : function () { return ''; };
    function safeGetURL(value) {
      try { return fn(value); } catch (e) { return ''; }
    }
    widget.methods = widget.methods || {};
    widget.methods.getURL = safeGetURL;
    if (widget.View) {
      widget.View.getURL = safeGetURL;
      if (widget.View.$options) {
        widget.View.$options.methods = widget.View.$options.methods || {};
        widget.View.$options.methods.getURL = safeGetURL;
      }
    }
  }

  function eachWidget(callback) {
    if (!window.Rebuy || !Rebuy.widgets) return;
    var list = Array.isArray(Rebuy.widgets) ? Rebuy.widgets : Object.keys(Rebuy.widgets).map(function (key) {
      return Rebuy.widgets[key];
    });
    list.forEach(callback);
  }

  ['rebuy.ready', 'rebuy.productsReady', 'rebuy.init'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var detail = event.detail;
      var widget = detail && (detail.widget || (detail.id != null ? detail : null));
      if (widget && widget.id != null) attachGetURL(widget);
      else eachWidget(attachGetURL);
    });
  });

  window.addEventListener('load', function () {
    eachWidget(attachGetURL);
  });

})();
